// Single source of truth for which games support the pair-and-cast flow,
// keyed by their slug. Each entry binds a game to:
//   - `path`: the controller's setup URL.
//   - `presenterChar`: the single character used in the short pairing URL
//     (`/<char><code>` → presenter view auto-paired). Must be unique and
//     URL-safe; a-z is fine.
//   - `peerNamespace`: the prefix used when registering a controller's peer
//     ID (`sfg-<peerNamespace>-<CODE>`). Two games sharing a namespace would
//     collide on the signaling server, so this stays unique per game.
export interface GameRegistryEntry {
  path: string
  peerNamespace: string
  presenterChar: string
}

export const GAME_REGISTRY = {
  'scoreboard': {
    path: '/games/scoreboard/',
    peerNamespace: 'scoreboard',
    presenterChar: 'b',
  },
  'showdown': {
    path: '/games/showdown/',
    peerNamespace: 'showdown',
    presenterChar: 's',
  },
  'sword-drill': {
    path: '/games/sword-drill/',
    peerNamespace: 'sword-drill',
    presenterChar: 'd',
  },
} as const satisfies Record<string, GameRegistryEntry>

export type GameKey = keyof typeof GAME_REGISTRY

export function gameByPresenterChar(char: string): GameRegistryEntry | null {
  for (const entry of Object.values(GAME_REGISTRY)) {
    if (entry.presenterChar === char) {
      return entry
    }
  }
  return null
}

export function isGameKey(value: string): value is GameKey {
  return value in GAME_REGISTRY
}
